import React, {  Component } from 'react';

export default class TargetArrivalDateDescriptionsOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('TargetArrivalDateDescriptionsOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                <a className="closeButton fontSize-10" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Target Arrival Date Descriptions</h2>
                    <div className="scroll-height-action-description">
    					<table className="dataTable actionDescriptionsTable">
    						<tbody>
    							<tr>
    								<td>The Target Arrival Date is the projected available date provided by the system at the time of order booking which represents the 
                                    <br/>earliest date that the product can arrive at the customer’s location. This is also referred to as the Scheduled Arrival Date in Oracle.</td>
    							</tr>
    						</tbody>
    					</table>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/targetArrivalDateDescriptionsOverlayDialog.js